export const AdminCallInsightsDashboards = {
  AdminCallInsightsDashboards: 
  {
    permissionsId:'ebf6d88b-2370-4f37-7977-08dcaf947ea8',
    permissionsName:'Admin Call Insights' , 
    componentsId:null,
    components:null
  }
} ;
